<template>
  <div>
    <div class="container-fluid mt-5">
      <el-row :gutter="20">
        <el-col :span="12" :offset="6">
          <el-steps :active="AktifStep" finish-status="success">
            <el-step title="Dosya Seçimi" description="Excel Dosyanızı Seçiniz"></el-step>
            <el-step title="Kontrol & Onay" description="İçe Aktarım için kontrol edin"></el-step>
            <el-step title="Veri Geçişi" description="Aktarım sonucu"></el-step>
          </el-steps>
        </el-col>
      </el-row>
    </div>

    <div v-if="AktifStep===1" class="mt-5">
      <el-row :gutter="20">
        <el-col :span="12" :offset="6">
          <div class="alert alert-info">Meskenlere ait sayaçların bulunduğu exceli seçiniz.<br>
            Hazırladığınız şablon Excel dosyasını ön izlemeli olarak göstereceğiz.
          </div>
          <el-row :gutter="24">
            <el-col :span="6">
              <a href="https://drive.google.com/uc?authuser=0&id=17LijESCWI8GwkAfr0-uxoWZWC-vpGuKp&export=download"
                 target="_blank" class="el-button el-button--primary btn-block">Şablon İndir <i
                class="el-icon-download el-icon-right"></i></a>
            </el-col>
            <el-col :span="18">
              <label for="file" type="button" class="el-button el-button--success btn-block">Excel
                Dosyası
                Yükle ve Hazırla <i class="el-icon-upload el-icon-right"></i></label>
              <input type="file" class="el-upload__input" id="file" accept=".xlsx,.xls"
                     @change="ExcelSecimi">
            </el-col>
          </el-row>

        </el-col>
      </el-row>
    </div>

    <div v-if="AktifStep===2" class="mt-5">
      <el-row :gutter="20" class="mb-5">
        <el-col :span="12" :offset="6">
          <div class="alert alert-info">Excel dosyanızı aşağıdaki tabloda derledik<br>
            Kontrol ederek içe aktarabilirsiniz.
          </div>
          <el-row :gutter="20">
            <el-col :span="16">
              <el-button type="primary" @click="AktifStep=1" icon="el-icon-caret-left">Dosya Seçimine
                Dön
              </el-button>
            </el-col>
            <el-col :span="8">
              <el-button type="success" @click="Onayla" class="float-right" icon="el-icon-check">
                Onayla ve
                içe Aktar
              </el-button>
            </el-col>

            <el-col :span="24">
              <hr>

              <table class="table table-hover table-sm">
                <thead>
                <tr>
                  <th>Daire No</th>
                  <th>Sayaç Tipi</th>
                  <th>Sayaç No</th>
                  <th>Endeks</th>
                  <th>Oda Çarpan</th>
                  <th>Oda Adı</th>
                  <th>Sayaç Marka</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(r, key) in data" v-if="key>0 && r[0]" :key="key">
                  <td v-for="c in cols"  :key="c.key"> {{ r[c.key] }} </td>
                </tr>
                </tbody>
              </table>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <div v-if="AktifStep===3" class="mt-5">
      <el-row :gutter="20" class="mb-5">
        <el-col :span="12" :offset="6">
          <div v-if="lo" class="alert alert-danger">Veriler işleniyor lütfen bekleyiniz.</div>
          <div v-if="!lo" class="alert alert-success">Verilerinizin geçişi tamamlandı<br>
            Bina artık sayaç okuma kullanmaya hazır.
          </div>
          <el-row>
            <el-col :span="24" v-if="!lo">
              <el-button type="success" @click="Yenile" class="float-right" icon="flaticon2-expand">
                Bina Ekran
              </el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import XLSX from 'xlsx';

  const make_cols = refstr => Array(XLSX.utils.decode_range(refstr).e.c + 1).fill(0).map((x, i) => ({
    name: XLSX.utils.encode_col(i),
    key: i
  }));

  export default {
    props: ['Bina_id'],
    data() {
      return {
        AktifStep: 1,
        lo: false,
        data: [],
        cols: [],
      }
    },
    methods: {
      Yenile() {
        location.reload();
      },
      Onayla() {

        this.AktifStep = 3;
        this.lo = true;
        this.$store.dispatch("Post", {Form: this.data, path: '_enerji/sayac/' + this.Bina_id})
          .then(response => {
            if (response.Durum == "OK") {
              this.lo = false;
              this.$router.push('/bina/' + this.Bina_id)
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
      ExcelSecimi(evt) {
        const files = evt.target.files;
        if (files && files[0]) this._file(files[0]);
      },
      _file(file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, {type: 'binary', cellDates: true, cellNF: false, cellText: false});
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          const data = XLSX.utils.sheet_to_json(ws, {raw: false, header: 1, dateNF: "DD-MM-YYYY"});
          this.data = data;
          this.cols = make_cols(ws['!ref']);
          this.AktifStep = 2;
        };
        reader.readAsBinaryString(file);
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Esayac/EsayacBinaKurulum.vue